import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import { Layer, LeafletMouseEvent, geoJSON } from 'leaflet'
import { Geometry, Feature, GeoJsonObject } from 'geojson'
import { Input, Button, Form } from 'antd'
import Map from '@/components/common/Map'
import { Container, InputContainer } from './styles'
import HistoryCarUsageMapHook from './HistoryCarUsageMap.hook'

const FitBounds: React.FC<{
  geoJson: GeoJsonObject
  setPeriodId: (id: string | undefined) => void
}> = ({ geoJson, setPeriodId }) => {
  const map = useMap()

  useEffect(() => {
    if (geoJson) {
      const geoJsonLayer = geoJSON(geoJson)
      const bounds = geoJsonLayer.getBounds()

      if (bounds.isValid()) {
        map.fitBounds(bounds) // Fit map to the GeoJSON bounds
      }
    }
  }, [geoJson, map])

  useEffect(() => {
    if (map) {
      const handleClickOutsideFeature = (e: LeafletMouseEvent) => {
        const clickedLayer = e.target
        if (!clickedLayer.feature) {
          setPeriodId(undefined)
        }
      }

      map.on('click', handleClickOutsideFeature)

      return () => {
        map.off('click', handleClickOutsideFeature)
      }
    }
  }, [map])

  return null
}

const FocusLocation = ({ center }) => {
  const map = useMap()
  useEffect(() => {
    if (center) {
      map.setView(center)
    }
  }, [center, map])
  return null
}

function HistoryCarUsageMap({
  geoJsonData,
  onEachFeature,
  setPeriodId,
}: {
  geoJsonData?: GeoJSON.FeatureCollection<Geometry>
  onEachFeature: (feature: Feature<Geometry, any>, layer: Layer) => void
  setPeriodId: (id: string | undefined) => void
}) {
  const [form] = Form.useForm()
  const { style, manualLocation, handleMark, handleChangeLocation, validateCoords } =
    HistoryCarUsageMapHook()

  return (
    <Container>
      <Map
        geoJson={geoJsonData}
        geoJsonStyle={style}
        onEachFeature={onEachFeature}
        locations={
          manualLocation
            ? [
                {
                  position: manualLocation,
                  useIconDefault: true,
                },
              ]
            : []
        }
      >
        <>
          {geoJsonData && <FitBounds geoJson={geoJsonData} setPeriodId={setPeriodId} />}
          {manualLocation && <FocusLocation center={manualLocation} />}
        </>
      </Map>
      <InputContainer>
        <Form
          form={form}
          onFinish={handleMark}
          layout="inline"
          onValuesChange={handleChangeLocation}
        >
          <Form.Item
            name="coords"
            normalize={(value) => value?.replaceAll(' ', '')}
            rules={[
              {
                validator: validateCoords,
              },
            ]}
          >
            <Input allowClear placeholder="กรุณากรอกพิกัด" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              ปักหมุด
            </Button>
          </Form.Item>
        </Form>
      </InputContainer>
    </Container>
  )
}

export default HistoryCarUsageMap
